export enum TipoIdentificador {
  CPF = 'CPF',
  CNPJ = 'CNPJ',
}
